/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';

import ContentFrame from '../../applicationFrame/ContentFrame';
import { ScrollAwareContext, ScrollAwareScroller, ScrollAwareAppNavStep } from '../../components/ScrollAware';
import { AppHeaderScrollableText } from '../../components/appNav/AppHeaderScrollable';

import SearchResults from './components/SearchResults';
import { useMedliSearch } from '../../hooks/useMedli';
import MedicalTermsModel from '../../../models/MedicalTermsModel';
import ContentLoader from '../../components/ContentLoader';

interface Props {
  suggestedResults: any[];
  title: string;
  selectSearchResult(r, i): void;
  cancelSearch(): void;
}
const StaticListView: React.FC<Props> = (props) => {
  const { suggestedResults, cancelSearch, title, selectSearchResult } = props;
  const suggestionsLoaded = suggestedResults.length > 0;

  return (
    <div>
      <ScrollAwareContext>
        <ScrollAwareAppNavStep
          cancel={cancelSearch}
          color="white"
        />

        <ContentFrame className="bkgd-color-light-neutral">
          <ScrollAwareScroller>
            <AppHeaderScrollableText id={title} />

            <ContentLoader isContentLoaded={suggestionsLoaded} blockRenderUntilLoaded={false} isFixed={true}>

              <SearchResults
                values={[{ searchResults: suggestedResults, header: null }]}
                query=""
                isSearchComplete={false}
                onSelectSearchResult={(medliSearchResult, index) => {
                  selectSearchResult(medliSearchResult, index);
                }}
              />
            </ContentLoader>
          </ScrollAwareScroller>
        </ContentFrame>
      </ScrollAwareContext>
    </div>
  );
};

export const MedliStaticListView = (props) => {
  const { title, suggestedResults, medliCategory, onGoBack, selectSearchResult } = props;
  const [, medliSearchActions] = useMedliSearch();

  return (
    <StaticListView
      suggestedResults={suggestedResults.map((r) => ({ searchResult: new MedicalTermsModel(r) }))}
      title={title}
      cancelSearch={() => {
        medliSearchActions.cancelSearch(medliCategory);
        onGoBack();
      }}
      selectSearchResult={(medliSearchResult, index) => {
        selectSearchResult(medliSearchResult.searchResult.data);
      }}
    />
  );
};

export default StaticListView;
